import React from 'react'
import { observer } from 'mobx-react-lite'

import { StoreScreenTabs, StoreScreenTabsBaseProps } from './StoreScreenTabs'

import { useStore } from '../hooks/storeHook'

import { makeOzonAccountName } from '../common/accountUtils'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'
import { OzonAccountModel } from '../server/mpsklad_core/Models/OzonAccountModel'

export type OzonScreenTabsProps = StoreScreenTabsBaseProps<OzonAccountModel>

export const OzonScreenTabs =
  observer(
    ({canAddAccount, ...props}: OzonScreenTabsProps) => {
      const {canAddOzonAccount, syncStore: {ozonAccounts}} = useStore()

      return <StoreScreenTabs
        storeType={IntegrationType.Ozon}
        storeAccounts={ozonAccounts}
        canAddAccount={canAddAccount && canAddOzonAccount}
        makeAccountName={makeOzonAccountName}
        {...props}
      />
    })